import React from "react";

export const Spinner = ({ size = "md", className = "" }) => {
    const sizes = {
        sm: "h-4 w-4",
        md: "h-8 w-8",
        lg: "h-12 w-12",
    };
    
    return (
        <svg
            className={`animate-spin text-indigo-600 ${sizes[size]} ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            role="status"
            aria-label="Loading"
        >
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
            />
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
        </svg>
    );
};

export default function Loader({ message = "Loading..." }) {
    return (
        <div 
            className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 dark:bg-slate-900/80 backdrop-blur-sm animate-fade-in"
            role="status"
            aria-live="polite"
            aria-label="Loading content"
        >
            <div className="flex flex-col items-center gap-4 animate-scale-in">
                <Spinner size="lg" className="text-indigo-600 dark:text-indigo-400" />
                {message && (
                    <p className="text-sm font-semibold text-slate-600 dark:text-slate-300 animate-pulse-slow">{message}</p>
                )}
            </div>
            <span className="sr-only">Loading content</span>
        </div>
    );
}